import * as React from 'react'
import classNames from 'classnames'
import './badge.scss'

interface BadgeProps {
  value?: number | boolean
  compact?: boolean
  className?: string
}

export class Badge extends React.Component<BadgeProps> {
  render(): React.ReactNode {
    const classes: string = classNames(
      'badge-icon',
      { 'badge-icon--active': this.props.value > 0 },
      { 'badge-icon--compact': this.props.compact },
      { [this.props.className]: !!this.props.className }
    )

    return (
      <span className={classes} aria-hidden="true">
        {(this.props.value > 0 && !this.props.compact) && this.props.value}
      </span>
    )
  }
}
